// extracted by css-extract-rspack-plugin
var _1 = "WSqwS9lGHwtvRr1R";
var _2 = "WSqwS9lGHwtvRr1R";
var _3 = "jpcBLEFdpSQYbBYy";
var _4 = "JKq_VDFv4RydbUA3";
var _5 = "xOd7hqN4ZKoa5au9";
var _6 = "Fm_RxCLTakkdHvy5";
var _7 = "xOd7hqN4ZKoa5au9";
var _8 = "Fm_RxCLTakkdHvy5";
var _9 = "j0w9CrSBVTYQQiB0";
export { _1 as "accept-button", _2 as "acceptButton", _3 as "logo", _4 as "placeholder", _5 as "policy-container", _6 as "policy-link", _7 as "policyContainer", _8 as "policyLink", _9 as "text" }
